"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const checkboxWidget_style_1 = __importDefault(require("./checkboxWidget.style"));
const CheckboxWidget = ({ classes, label, value, options }) => {
    const { enumOptions } = options;
    /**
     * @returns a pair {label, value}
     */
    const selectedOption = enumOptions.find(option => option.value === value) || {
        label: value
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.wrapper }, { children: [!selectedOption.label && jsx_runtime_1.jsx("div", { className: classes.emDash }, void 0),
                    jsx_runtime_1.jsx("span", { children: label }, void 0)] }), void 0),
            selectedOption.label && (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.wrapper }, { children: [jsx_runtime_1.jsx("div", { className: classes.emDash }, void 0),
                    jsx_runtime_1.jsx("span", { children: selectedOption.label }, void 0)] }), void 0))] }, void 0));
};
exports.CheckboxWidget = CheckboxWidget;
exports.default = react_jss_1.default(checkboxWidget_style_1.default)(exports.CheckboxWidget);
//# sourceMappingURL=index.js.map